import React from 'react';
import { BehaviorSubject } from 'rxjs';
import { AggregationSelections } from 'src/components/CategoryListingPage/utils/cleanAggregations';

import { ProductListItems } from './ProductListItems';
import { useProductListGtm } from './hooks/useProductListGtm';

export type ProductListProps = {
    products: any[];
    loading: boolean;
    listName?: string;
    listId?: string;
    onChange?: (checked: boolean, code: string, label: string) => void;
    selection$?: BehaviorSubject<AggregationSelections>;
    algolia?: boolean;
    algoliaSelections?: string[];
    modalMode?: boolean;
    onAction?: (id: number, name: string, options?: any, image?: string) => void;
};

export const ProductList: React.FunctionComponent<ProductListProps> = ({
    products,
    listName,
    listId,
    loading,
    onChange,
    selection$,
    algolia,
    algoliaSelections,
    modalMode = false,
    onAction,
}) => {
    const productPartOne = products.slice(0, 8);
    const productPartTwo = products.slice(8, 9);
    const productPartThree = products.slice(9, products.length);
    const productAndQuickQuote = [
        ...productPartOne,
        'quickQuoteWrapper1',
        ...productPartTwo,
        'quickQuoteWrapper2',
        ...productPartThree,
    ];

    /**
     * GTM
     */
    const { gtmSelectItem } = useProductListGtm({
        products: productAndQuickQuote,
        listName: listName,
        listId: listId,
    });

    return (
        <ProductListItems
            products={productAndQuickQuote}
            gtmSelectItem={gtmSelectItem}
            loading={loading}
            listId={listId}
            onChange={onChange}
            selection$={selection$}
            algolia={algolia}
            algoliaSelections={algoliaSelections}
            modalMode={modalMode}
            onAction={onAction}
        />
    );
};
